import autoBind from 'auto-bind';
import { AxiosInstance } from 'axios';
import { API } from '../baseUrl';
import create from '../common.http';

export default class TransferTrackingService {
	private transferTrackingApi: AxiosInstance;

	constructor() {
		this.transferTrackingApi = create(API.TRANSFER_TRACKING);
		autoBind(this);
	}

	public async postSearchOrderNumber(req: any, token: string): Promise<any> {
		const response = await this.transferTrackingApi.post(`/web/order-tracking/search`, req, { headers: { 'x-captcha-token': token } });
		return response;
	}
}
